let googleMapsPromise = null;

export const googleMapsBrowserKey = () => (
  process.env.REACT_APP_GOOGLE_MAPS_BROWSER_API_KEY || ''
);

export const loadGoogleMaps = () => {
  if (window.google?.maps?.importLibrary) return Promise.resolve(window.google.maps);
  if (googleMapsPromise) return googleMapsPromise;

  const key = googleMapsBrowserKey();
  if (!key) {
    return Promise.reject(new Error('Google Maps is not configured.'));
  }

  googleMapsPromise = new Promise((resolve, reject) => {
    const callbackName = '__dopatizeGoogleMapsReady';
    const script = document.createElement('script');
    const params = new URLSearchParams({
      key,
      v: 'weekly',
      loading: 'async',
      libraries: 'maps,places',
      callback: callbackName,
    });
    window[callbackName] = () => {
      delete window[callbackName];
      resolve(window.google.maps);
    };
    script.async = true;
    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
    script.onerror = () => {
      delete window[callbackName];
      googleMapsPromise = null;
      reject(new Error('Google Maps could not load.'));
    };
    document.head.appendChild(script);
  });
  return googleMapsPromise;
};
